import { Button, Checkbox, Select, TextBox } from "@veneer/core";
import { Col, Container, Row } from "react-bootstrap";
import {
  POST_ADD_USER,
  POST_CONTACT_EDIT,
  POST_PROFILE_ADD_CONTACT,
} from "../../../../services";
import { apiPost } from "../../../../services/service";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  validateField,
  validateForm,
} from "../../../../form-validation/form-Validation";
import Loader from "../../shared-components/loader/loader";
import { Trans, useTranslation } from "react-i18next";
import { HelpModalPopup } from "@components/home-page/shared-components/modal-popup/help-modal-popup";
import { getCountry, getFieldError, onSearchDropDown } from "utils";
import { getValidatedNumberInput } from "utils";
import { useAppSelector } from "@store/hooks";
import { RootState } from "@store/store";

interface State {
  [key: string]: string;
}

interface FormStateType {
  [key: string]: any;
}

export const AddNewContact = (props: any) => {
  const [progress, setProgress] = useState(false);
  const [isadmin, setAdmin] = useState<boolean>(false);
  const [popupTilte, setPopupTitle] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [countryCodes, setCountryCodes] = useState([]);
  const [filteredCountryList, setFilteredCountryList] = useState([]);

  const [filteredCountryCodes, setFilteredCountryCodes] = useState(countryCodes || []);

  const [filteredAltCountryCodes, setFilteredAltCountryCodes] = useState(countryCodes || []);

  const [formState, setFormState] = useState<FormStateType>({
    firstNamesavedContacts: "",
    lastNamesavedContacts: "",
    phNumsavedContacts: "",
    phNumAlternativesavedContacts: "",
    emailsavedContacts: "",
    extensionsavedContacts: "",
    extensionAlternativesavedContacts: "",
    countryNamesavedContacts: "",
  });
  const { t } = useTranslation();
  const popupHeader = () => {
    return (
      <p className="popup-header">
        <img
          src="https://logos-world.net/wp-content/uploads/2020/11/HP-Logo.png"
          alt=""
          style={{ height: "46px", width: "auto" }}
        />
        <span>{popupTilte}</span>
      </p>
    );
  };

  const handleCallBack = (title: string) => {
    setPopupTitle(title);
    setOpen(true);
  };

  const fetchCountry = async () => {
    try {
      let country: any = await getCountry();
      setCountryList(country?.country);
      setCountryCodes(country?.code);
      setFilteredCountryCodes(country?.code);
      setFilteredAltCountryCodes(country?.code);

      setFilteredCountryList(country?.country);
    } catch (error) {
      console.error("Error fetching country: ", error);
    }
  };

  useEffect(() => {
    fetchCountry();
  }, []);

  useEffect(() => {
    if (props.data && props.data !== "addminitrator") {
      setErrorState({});
      setFormState({
        ...props?.data?.[0],
        firstNamesavedContacts: props?.data ? props?.data?.[0]?.firstname : "",
        lastNamesavedContacts: props?.data ? props?.data?.[0]?.lastname : "",
        phNumsavedContacts: props?.data ? props?.data?.[0]?.phNum.replace('+' + props?.data?.[0]?.countryCode, ''): "",
        phNumAlternativesavedContacts: props?.data ? props?.data?.[0]?.phNumAlternative.replace('+' + props?.data?.[0]?.countryCode, '') : "",

        emailsavedContacts: props?.data ? props?.data?.[0]?.email : "",
        extensionsavedContacts: props?.data ? props?.data?.[0]?.extension : "",
        extensionAlternativesavedContacts: props?.data
          ? props?.data?.[0]?.extensionAlternative
          : "",
        contactid: props.contactid,
        countryNamesavedContacts: props?.data ? props?.data?.[0]?.countryId : "",
        phNumTypeAlternative: props?.data ? props?.data?.[0]?.countryId : "",
        selectedaccountid: props?.data ? props?.data?.[0]?.parentCustomerId : "",
        tabid: "savedContacts",

      });
    }
  }, [props.data]);
  useEffect(() => {
    if (props.module === "addminitrator") {
      setFormState((prevState) => ({
        ...prevState,
        ["selectedaccountid"]: props.parentCompany?.AccountID,
      }));
    }
  }, [props.parentCompany]);
  const [errorState, setErrorState] = useState<State>({});

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    let FormErrors = validateForm(
      formState,
      props?.module === "addminitrator" ? "addministrator" : "saveContact",t
    );
    setErrorState(FormErrors);
    if (Object.keys(FormErrors).length > 0) {
      toast.error(t('HPI.ErrorMessage.FillRequiredFields',{defaultValue:'Please fill the required fields'}));
    } else {
      try {
        setProgress(true);
        let payload: any = {


          ...formState,
        };
        let url =
          props.title === "Edit contact" 
            ? POST_CONTACT_EDIT
            : POST_PROFILE_ADD_CONTACT;

        if (props.title === "Edit contact") {
          payload = {
            ...formState,
            email: formState?.emailsavedContacts,
            firstname: formState?.firstNamesavedContacts,
            lastname: formState?.lastNamesavedContacts,
            phNum: formState?.phNumsavedContacts,
            phNumAlternative: formState?.phNumAlternativesavedContacts,
            extension: formState?.extensionsavedContacts,
            extensionAlternative: formState?.extensionAlternativesavedContacts,
            countryId: formState?.countryNamesavedContacts
          };
        }
        if (props.module === "addminitrator") {
          url = POST_ADD_USER;
          payload = {
            selectedaccountid: formState?.selectedaccountid,
            adminfirstNamesavedContacts: formState?.firstNamesavedContacts,
            adminlastNamesavedContacts: formState?.lastNamesavedContacts,
            adminphNumsavedContacts: formState?.phNumsavedContacts,
            adminextensionsavedContacts: formState?.extensionsavedContacts,
            adminphNumTypesavedContacts: "",
            adminphNumAlternativesavedContacts:
              formState?.phNumAlternativesavedContacts,
            adminextensionAlternativesavedContacts:
              formState?.extensionAlternativesavedContacts,
            adminphNumTypeAlternativesavedContacts: "",
            adminemailsavedContacts: formState?.emailsavedContacts,
            isAdmin: formState?.isAdmin ? true : false,
            countryId: formState?.countryNamesavedContacts
          };
        }

        let saveContact = await apiPost(url, payload);
        if (saveContact.data) {
          let res = saveContact.data;
          setProgress(false);
          toast.success(res.successmessage);
          const warnings = res?.contactwarningmessages;
          if (warnings) {
            if (warnings.PrimayContactWarning) {
              toast.warning(`${warnings.PrimayContactWarning}`);
            }
            if (warnings.AlternateContactWarning) {
              toast.warning(`Alternate Contact Warning: ${warnings.AlternateContactWarning}`);
            }
            if (warnings.EquipContactWarning) {
              toast.warning(`Equipment Contact Warning: ${warnings.EquipContactWarning}`);
            }
            if (warnings.ShippingContactWarning) {
              toast.warning(`Shipping Contact Warning: ${warnings.ShippingContactWarning}`);
            }
          }
          setFormState({
            firstNamesavedContacts: "",
            lastNamesavedContacts: "",
            phNumsavedContacts: "",
            phNumAlternativesavedContacts: "",
            emailsavedContacts: "",
            extensionsavedContacts: "",
            extensionAlternativesavedContacts: "",
            selectedaccountid: "",
          });
          props.fetchdata();
          if (props.title === "Edit contact") {
            props && props?.handleEditcase();
          }
        } else {
          toast.error(saveContact?.Message || saveContact?.message);
          setProgress(false);
        }
      } catch (error) {
        setProgress(false);
      }
    }
  };

  const handleSelectChange = (selectedOption: any, name: any) => {
    setFormState((prevState) => ({
      ...prevState,
      [name]: selectedOption.value,
    }));
    if (name === "selectedaccountid") {
      setFormState((prevState) => ({
        ...prevState,
        ["selectedaccountid"]: selectedOption.value,
      }));
    }
    validateField(name, selectedOption.value, setErrorState,t);
  };

  const handleChange = (v: any, e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormState((prevState: any) => ({
      ...prevState,
      [name]: v,
    }));

    if (['phNumsavedContacts', 'phNumAlternativesavedContacts', 'emailsavedContacts'].includes(name)) {
      setErrorState((prevState) => ({
        ...prevState,
        [name]: '',
      }));
    } else {
      validateField(name, v, setErrorState,t);
    }

  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (value) {
      validateField(name, value, setErrorState,t);
    }
  };

  const clearSelectHandler = (field: any) => {
    setFormState((prevData) => ({ ...prevData, [field]: [""] }));
  };

  const onSelectChangeHandler = (selectedOption: any, k: any) => {
    setFormState((prevData) => ({
      ...prevData,
      [k]: [selectedOption?.value],
    }));
  }

  return (
    <div className="add-new-Contact">
      {progress && (
        <div className="loader-overlay">
          <div className="loader-css">
            <Loader />
          </div>
        </div>
      )}
      <form
        id="Profile-settings-form"
        className="profile-form"
        onSubmit={handleSubmit}
      >
        {props?.module === "addminitrator" && (
          <div>
            <p className="body-regular">
              {t("HPI.Profilepage.CreateContacts.admin.newuser", {
                defaultValue:
                  "Add new users or Activate and Deactivate existing users.",
              })}
            </p>

            <div className="input-container">
              <div className="tooltip-container">
                <div className="label-container ">
                  <h3 className="subtitle-large">
                    {t("HPI.Profilepage.CreateContacts.admin.selectAccount", {
                      defaultValue: "Step 1 Select Account",
                    })}
                  </h3>

                  <span className="supporting-text ml-2">
                    <HelpModalPopup
                      align={"start"}
                      id={"modal-popup"}
                      show={open}
                      onClose={() => setOpen(false)}
                      title={popupHeader()}
                      callback={() => handleCallBack(t("HPI.ProfilePage.AddNewUserTooltip.Header", { defaultValue: 'Adding a new user' }))}
                    >
                      <p dangerouslySetInnerHTML={{__html:t("HPI.ProfilePage.AddNewUserTooltip.Content", { defaultValue: "Fill in the information below to add a new user to your company account:<br><br>1) Choose account user should be associated with.<br>2) Fill in contact information for new user.<br>3) Check “admin” box if user should have admin privileges.<br><br>After adding the user to this list, they will receive an invite code via the email provided. Please ensure you use the correct company email for this user." })}}>
                        
                      </p>
                    </HelpModalPopup>
                  </span>
                </div>
              </div>
            </div>

            <Row>
              <Col className="">
                <Select
                  options={props.companyList}
                  label={
                    props.companyList
                      ? `${t(
                        "HPI.Profilepage.CreateContacts.admin.ParentAccount",
                        { defaultValue: "Parent Accounts" }
                      )} ${props.parentCompany?.AccountName}`
                      : ""
                  }
                  separateLabel
                  placeholder="Select Parent Account"
                  required
                  clearIcon={false}
                  name="selectedaccountid"
                  value={[formState?.["selectedaccountid"]]}
                  error={errorState["selectedaccountid"] ? true : false}
                  helperText={errorState["selectedaccountid"] || ""}
                  onChange={(selectedOption: any) => {
                    handleSelectChange(selectedOption, "selectedaccountid");
                  }}
                  className="textbox"
                />
              </Col>
            </Row>

            <h3 className="subtitle-large">
              {t("HPI.Profilepage.contactInfo.newuser", {
                defaultValue:
                  "Step 2: Provide contact information for new users.",
              })}
            </h3>
          </div>
        )}

        <h4 className="subtitle-regular">
          {props.title
            ? (props.title === "Edit contact")? t('HPI.Profilepage.savedContacts.Editcontact',{defaultValue:'Edit contact'}):props.title
            : t("HPI.Profilepage.CreateContacts.addnewcontact", {
              defaultValue: "Add a new contact",
            })}
        </h4>
        <p className="caption-small m-1">
          <span className="error">*</span>{" "}
          {t("HPI.Profilepage.savedContacts.RequiredFields", {
            defaultValue: "Required fields",
          })}
        </p>

        <Container className="add-new-Contact-form"> 
        <Row>
              <Col className="">
                <Select
                  options={ props.companyList}
                  label={t("HPI.Profilepage.myprofile.Accountname", {
                    defaultValue: "Account name",
                  })}
                  separateLabel
                  placeholder="Select Account name"
                  required
                  clearIcon={false}
                  name="selectedaccountid"
                  value={props.title === "Edit contact" ? [formState?.["selectedaccountid"]]:[formState?.["selectedaccountid"]]}
                  error={errorState["selectedaccountid"] ? true : false}
                  helperText={errorState["selectedaccountid"] || ""}
                  onChange={(selectedOption: any) => {
                    handleSelectChange(selectedOption, "selectedaccountid");
                  }}
                  className="textbox"
                />
              </Col>
            </Row>
          
          <Row>
            <Col col={12} md={6}>
              <TextBox
                label={t("HPI.Profilepage.savedContacts.Firstname", {
                  defaultValue: "First name",
                })}
                placeholder={t("HPI.Profilepage.Placeholder.EnterFirstName", {
                  defaultValue: "Enter first name",
                })}
                separateLabel
                required
                className="textbox"
                name="firstNamesavedContacts"
                error={errorState["firstNamesavedContacts"] ? true : false}
                helperText={errorState["firstNamesavedContacts"] || ""}
                onChange={(v: any, e) => {
                  handleChange(v, e);
                }}
                value={formState?.["firstNamesavedContacts"]}
              />
            </Col>

            <Col col={12} md={6}>
              <TextBox
                defaultValue=""
                label={t("HPI.Profilepage.savedContacts.Lastname", {
                  defaultValue: "Last name",
                })}
                placeholder={t("HPI.Profilepage.Placeholder.EnterLastName", {
                  defaultValue: "Enter last name",
                })}
                separateLabel
                required
                className="textbox"
                name="lastNamesavedContacts"
                error={errorState["lastNamesavedContacts"] ? true : false}
                helperText={errorState["lastNamesavedContacts"] || ""}
                value={formState?.["lastNamesavedContacts"]}
                onChange={(v: any, e) => {
                  handleChange(v, e);
                }}
              />
            </Col>
          
            {/* {[formState["countryNamesavedContacts"]]} */}

              <Col lg={2} md={6}>
                <Select
                  separateLabel
                  options={filteredCountryCodes}
                  showSearch
                  //required
                  name="countryId"
                  label={t('HPI.ProfilePage.cs.SelectCountryCode',{defaultValue:'Code'})}
                  placement="bottom"
                  placeholder={t('HPI.ProfilePage.cs.SelectCountryCode',{defaultValue:'Code'})}
                  value={[formState["countryNamesavedContacts"]]}
                  helperTextVisibility="auto"
                  
                  onClear={() => {
                    clearSelectHandler("countryId");
                    clearSelectHandler("countryNamesavedContacts");
                  }}
                  onChange={(selectedOption: any) => {
                    onSelectChangeHandler(selectedOption, "countryId")
                    handleSelectChange(selectedOption, "countryNamesavedContacts");
                  }
                }
                  {...getFieldError(errorState, "countryId")}
                  onSearch={(value: any) => {
                    let filtered: any = onSearchDropDown(countryCodes, value);
                    setFilteredCountryCodes(filtered);
                  }}
                  className="textbox"
                />
              </Col>
              <Col lg={4} md={6} className="input-container">
                <div className="tooltip-container">
                  <div className="label-container ">
                    <label>
                      {t("HPI.Profilepage.savedContacts.Phonenumber", {
                        defaultValue: "Phone number (main)",
                      })}
                      <span className="error">*</span>
                    </label>

                    <span className="supporting-text">
                      <HelpModalPopup
                        align={"start"}
                        id={"modal-popup"}
                        show={open}
                        onClose={() => setOpen(false)}
                        title={popupHeader()}
                        callback={() => handleCallBack(t("HPI.CreateCase.Contactinformation.Phonenumber", { defaultValue: ' Phone Number' }))}
                      >
                        <p>
                          {t("HPI.Profilepage.PhoneNumberToolTip.body", { defaultValue: "Please enter no more than 15 numerals, starting with country code do not use '+' or any other characters;" })}
                        </p>
                      </HelpModalPopup>
                    </span>

                  </div>
                  <TextBox
                    // label={t("HPI.Profilepage.savedContacts.Phonenumber", {
                    //   defaultValue: "Phone number (main)",
                    // })}
                    placeholder={t("HPI.CreateCase.Placeholder.EnterPhoneNumber", {
                      defaultValue: "Enter phone number",
                    })}
                    separateLabel
                    required
                    className="textbox"
                    name="phNumsavedContacts"
                    error={errorState["phNumsavedContacts"] ? true : false}
                    helperText={errorState["phNumsavedContacts"] || ""}
                    onBlur={(e) => handleBlur(e)}
                    onChange={(v: any, e) => {
                      const value = getValidatedNumberInput(v, 15);
                      if (value.length <= 15) {
                        handleChange(value, e);
                      }
                    }}

                    value={formState?.["phNumsavedContacts"]}
                  />
                </div>
              </Col>
              <Col md={6} className="input-container">
                <div className="tooltip-container">
                  <div className="label-container ">
                    <label>
                      {t("HPI.Profilepage.savedContacts.Extension", {
                        defaultValue: "Extension",
                      })}
                    </label>
                    <span className="supporting-text">
                      <HelpModalPopup
                        align={"start"}
                        id={"modal-popup"}
                        show={open}
                        onClose={() => setOpen(false)}
                        title={popupHeader()}
                        callback={() => handleCallBack(t("HPI.Profilepage.exttooltip.header", { defaultValue: 'Extension code' }))}
                      >
                        <p>
                          {t("HPI.Profilepage.exttooltip.body", { defaultValue: "The extension code must contain only digits, up to a maximum length of 5." })}
                        </p>
                      </HelpModalPopup>
                    </span>
                  </div>
                  <TextBox
                    // label={t("HPI.Profilepage.savedContacts.Extension", {
                    //   defaultValue: "Extension",
                    // })}
                    placeholder={t("HPI.Profilepage.Placeholder.EnterExtension", {
                      defaultValue: "Enter extension",
                    })}
                    separateLabel
                    name="extensionsavedContacts"
                    className="textbox"

                    onChange={(v: any, e) => {
                      const value = getValidatedNumberInput(v, 5);
                      if (value.length <= 5) {
                        handleChange(value, e);
                      }
                    }}
                    value={formState?.["extensionsavedContacts"]}
                  />
                </div>
              </Col>
            
            <Col lg={2} md={6} >
              <Select
                separateLabel
                options={filteredAltCountryCodes}
                showSearch
                // required
                name="phNumTypeAlternative"
                label="Code"
                placement="bottom"
                placeholder="Code"
                value={[formState["phNumTypeAlternative"]]}
                helperTextVisibility="auto"
                
                onClear={() => {
                  clearSelectHandler("phNumTypeAlternative");
                }}
                onChange={(selectedOption: any) =>{
                  handleSelectChange(selectedOption, "phNumTypeAlternative");
                  //onSelectChangeHandler(selectedOption, "phNumTypeAlternative")
                }
                }
                {...getFieldError(errorState, "phNumTypeAlternative")}
                onSearch={(value: any) => {
                  let filtered: any = onSearchDropDown(countryCodes, value);
                  setFilteredAltCountryCodes(filtered);
                }}
                className="textbox"
              />
            </Col>

            <Col lg={4} md={6} className="input-container">
              <div className="tooltip-container">
                <div className="label-container ">
                  <label>
                    {t("HPI.Profilepage.savedContacts.alternatenumber", {
                      defaultValue: "Phone number (alternate)",
                    })}
                    {/* <span className="error">*</span> */}
                  </label>

                  <span className="supporting-text">
                    <HelpModalPopup
                      align={"start"}
                      id={"modal-popup"}
                      show={open}
                      onClose={() => setOpen(false)}
                      title={popupHeader()}
                      callback={() => handleCallBack(t("HPI.CreateCase.Contactinformation.Phonenumber", { defaultValue: ' Phone Number' }))}
                    >
                      <p>
                        {t("HPI.Profilepage.PhoneNumberToolTip.body", { defaultValue: "Please enter no more than 15 numerals, starting with country code do not use '+' or any other characters;" })}
                      </p>
                    </HelpModalPopup>
                  </span>
                </div>

                <TextBox
                  defaultValue=""
                  // label={t("HPI.Profilepage.savedContacts.alternatenumber", {
                  //   defaultValue: "Phone number (alternate)",
                  // })}
                  placeholder={t('HPI.Profilepage.Placeholder.EnterAlternatePhoneNumber',{defaultValue:'Enter alternate phone number'})}
                  separateLabel
                  error={
                    errorState["phNumAlternativesavedContacts"] ? true : false
                  }
                  helperText={errorState["phNumAlternativesavedContacts"] || ""}
                  className="textbox"
                  name="phNumAlternativesavedContacts"
                  onBlur={(e) => handleBlur(e)}
                  required
                  onChange={(v: any, e) => {
                    const value = getValidatedNumberInput(v, 15);
                    if (value.length <= 15) {
                      handleChange(value, e);
                    }
                  }}
                  value={formState?.["phNumAlternativesavedContacts"]}
                />
              </div>
            </Col>
            <Col col={12} md={6} className="input-container">
              <div className="tooltip-container">
                <div className="label-container ">
                  <label>
                    {t("HPI.Profilepage.savedContacts.alternatextension", {
                      defaultValue: "Extension",
                    })}
                  </label>

                  <span className="supporting-text">
                    <HelpModalPopup
                      align={"start"}
                      id={"modal-popup"}
                      show={open}
                      onClose={() => setOpen(false)}
                      title={popupHeader()}
                      callback={() => handleCallBack(t("HPI.Profilepage.exttooltip.header", { defaultValue: 'Extension code' }))}
                    >
                      <p>
                        {t("HPI.Profilepage.exttooltip.body", { defaultValue: "The extension code must contain only digits, up to a maximum length of 5." })}
                      </p>
                    </HelpModalPopup>
                  </span>
                </div>
                <TextBox
                  defaultValue=""
                  // label={t("HPI.Profilepage.savedContacts.alternatextension", {
                  //   defaultValue: "Extension",
                  // })}
                  placeholder={t(
                    "HPI.Profilepage.Placeholder.EnterExtension",
                    { defaultValue: "Enter extension" }
                  )}
                  separateLabel
                  name="extensionAlternativesavedContacts"
                  className="textbox"
                  onChange={(v: any, e) => {
                    const value = getValidatedNumberInput(v, 5);
                    if (value.length <= 5) {
                      handleChange(value, e);
                    }
                  }}
                  value={formState?.["extensionAlternativesavedContacts"]}
                />
              </div>
            </Col>

            <Col col={12} md={6}>
              <TextBox
                defaultValue=""
                label={t("HPI.Profilepage.savedContacts.alterEmail", {
                  defaultValue: "Email",
                })}
                placeholder={t("HPI.Profilepage.Placeholder.EnterEmail", {
                  defaultValue: "Enter email",
                })}
                separateLabel
                required
                disabled={props.title === "Edit contact" ? true : false}
                className="textbox"
                name="emailsavedContacts"
                error={errorState["emailsavedContacts"] ? true : false}
                helperText={errorState["emailsavedContacts"] || ""}
                onChange={(v: any, e) => {
                  handleChange(v, e);
                }}
                onBlur={(e) => handleBlur(e)}
                value={formState?.["emailsavedContacts"]}
              />
            </Col>
              
            <Col col={12} md={6}>
              <Select
                options={filteredCountryList || []} //portalLanguageId
                //helperText="Helper Text"
                label={t("HPI.Profilepage.myprofile.Address.CountryRegion", {
                  defaultValue: "Country/Region",
                })}
                placeholder={t(
                  "HPI.Profilepage.myprofile.Address.CountryRegion",
                  { defaultValue: "Country/Region" }
                )} //
                className="textbox"
                
                separateLabel
                name="countryNamesavedContacts"
                
                 onClear={() => {
                    clearSelectHandler("countryId");
                    clearSelectHandler("countryNamesavedContacts");
                  }}
                error={errorState["countryNamesavedContacts"] ? true : false}
                helperText={errorState["countryNamesavedContacts"] || ""}
                onChange={(selectedOption: any) => {
                  handleSelectChange(selectedOption, "countryNamesavedContacts");
                  
                }}
                showSearch
                required
                onSearch={(value: any) => {
                  let filtered: any = onSearchDropDown(countryList, value);
                  setFilteredCountryList(filtered);
                }}
                value={[formState["countryNamesavedContacts"]]} 
              />
            </Col>
            {props.module === "addminitrator" && (
              <Col col={12} md={6} className="mt-4 pt-2">
                <Checkbox
                  name="isAdmin"
                  className="textbox"
                  label={t("HPI.Profilepage.contactInfo.adminrole", {
                    defaultValue: "Create user as admin role",
                  })}
                  checked={isadmin}
                  onChange={() => {
                    setFormState((prevState: any) => ({
                      ...prevState,
                      ["isAdmin"]: !isadmin,
                    }));
                    setAdmin(!isadmin);
                  }}
                />
              </Col>
            )}
          </Row>

          <Row className="mt-3 mb-4">
            <Col col={12} md={10} dangerouslySetInnerHTML={{ __html: t('HpPrivacyStatementLink', { defaultValue: `<p>By completing and submitting this form you consent to the use of your data in accordance with HP's Privacy statement.&nbsp;<a target=\"_blank\" href=\"http://www8.hp.com/us/en/privacy/privacy.html\">Learn more about HP's privacy policy</a></p>` }) }}>
            </Col>
            <Col col={12} md={2}>
              <Button type="submit">
                {props.btnName
                  ? props.btnName
                  : t("HPI.btnAddcontact", {
                    defaultValue: "Add contact",
                  })}
              </Button>
            </Col>
          </Row>
        </Container>
      </form>
    </div>
  );
};
